module.exports = __webpack_public_path__ + "img/banner_racing.76669280.jpg";